import type { UiConfigOverlay } from "@repo/ui-config";

function isUnknownRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function readUiConfigOverlayLanguageLocale(
  overlay: UiConfigOverlay,
): string | undefined {
  const language = overlay.lenses?.language;
  if (!isUnknownRecord(language)) {
    return undefined;
  }

  return typeof language.locale === "string" ? language.locale : undefined;
}

export function preserveUiConfigLanguageOverlayFields(
  language: unknown,
): Readonly<Record<string, unknown>> {
  return isUnknownRecord(language) ? language : {};
}
